import { makeStyles } from 'tss-react/mui';

const useStylesRightDrawer: MaterialUIStylesCallback = makeStyles()((): MaterialUIStyles => ({
  rightDrawer: {
    width: 300,
    height: 'calc(100% - 64px) !important',
    marginTop: 64,
  },
}));

export default useStylesRightDrawer;
